/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/forwardcommandunits.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/gensetstatus.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/drystatus.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import ReeferCallout from '../../actions/ReeferCallout';
import { RCUtils } from './../../RCUtils';
import { DryHistoryGrid } from './DryHistoryGrid';
import Formatters from '../../actions/Formatters';
import DryFormatters from '../../actions/DryFormatter';
import { DryCellRenderer } from '../../actions/DryCellRenderer';
import * as Exceljs from '../../actions/ExportToExcel.js';
import $ from 'jquery';
import uniq from 'lodash/uniq';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import CCAlmTooltip from '../sharedcomponents/GridToolTips/CCAlmTooltip';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import './../../../node_modules/react-toggle-switch/dist/css/switch.min.css';
import { EmailControlExcel } from './../sharedcomponents/EmailControlExcel';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { DryStatusToggleButtonsFilter } from '../childcomponents/DryStatusToggleButtonsFilter';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import { GridDryStatusToolBar } from '../sharedcomponents/GridDryStatusToolBar';
import { AssignToCustomer } from '../childcomponents/AssignToCustomer';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import { UnassignReefersFromCustomer } from '../childcomponents/UnassignReefersFromCustomer';
import { DryPingControl } from './../sharedcomponents/ForwardCommands/DryCommands/DryPingControl';
import { MRelatedReportingInterval } from './../sharedcomponents/ForwardCommands/DryCommands/MRelatedReportingInterval';
import { ExportToExcelConfirmationWindow } from '../sharedcomponents/ExportToExcelConfirmationWindow';
import { EmailControlExcelPreference } from '../sharedcomponents/EmailControlExcelPreference';
import UserRights from '../../actions/UserRights';
var Config: any = require('../../Config.json');
var Excel = Exceljs.default;

interface DryGridState {
    loading: boolean;
    Filters: server.ReeferSearchFilters;
    rowData: any[];
    columnDefs: any[];
    selectedItems: any[];
    overlayLoadingTemplate: any;
    modelTitle: string;
    popUpHtml: any;
    isChangeDeforstInterval: boolean;
    pretripCmd: string;
    reeferFormatter: server.ReeferFormatter[];
    pageSize: any;
    gridApiParams: any;
    tempFilters: server.ReeferSearchFilters;
    exportFields: ExportFields;
    defaultColDef: any[];
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    PrevEndRow: any;
    PrevStartRow: any;
    frameworkComponents: any;
    rowModelname: string;
    serverSideStoreType: any;
}

class ExportFields {
    ExportData: string;
}

var currentMousePos = { x: -1, y: -1 };
var self;
var selectedRowData;
var coppiedData;
var coppiedDataWithHeader;
var customerTypeCd;
var functionId;
var customerAccessData: any[];
var columnDefs2: any[];
var columnDefs: any[];
var dryAssetSensors: any[];
var commandIssued: boolean = false;
var selectedRowIndex: number;
var IsTriggered: boolean;
var serverSideEnabled: boolean;
var previousDryid;
export class DryStatusSSRMGrid extends React.Component<any, DryGridState> {
    constructor(props: any) {
        super(props);
        customerAccessData = [];
        selectedRowIndex = -1;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        //customerTypeCd = props.loggedInUserData.User.Customer.CustomerTypeCd;
        functionId = 48; // functionId for Dry Status Grid
        serverSideEnabled = true;
        // new FilterDto();
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        var exportData = new ExportFields();
        this.state = {
            loading: true,
            Filters: this.props.statusFilter,
            //rowData: this.props.propsDryData,
            rowData: [],
            columnDefs: [], selectedItems: [],
            overlayLoadingTemplate: overlayTemplate,
            modelTitle: '',
            popUpHtml: '',
            isChangeDeforstInterval: false,
            pretripCmd: null,
            reeferFormatter: [],
            tempFilters: null,
            pageSize: 1000,
            gridApiParams: [],
            exportFields: exportData,
            defaultColDef: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            IsCommandIssued: false,
            PrevSelectedItems: [],
            autoGroupColumnDef: { minWidth: 200 },
            PrevEndRow: -1,
            PrevStartRow: -1,
            frameworkComponents: { cCAlmTooltip: CCAlmTooltip },
            rowModelname: 'serverSide',
            serverSideStoreType: 'partial'
        };


        self = this;
    }

    componentWillReceiveProps(nextprops: any) {
        const propsDryData: any = this.props.propsDryData;
        //if (propsDryData !== nextprops.propsDryData)
            //this.setState({ rowData: [] });
        if (nextprops.propsDryData != null && nextprops.propsDryData != undefined && nextprops.propsDryData.length > 0 && nextprops.statusFilter.StatusFilters != undefined
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.AllReefer && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.Running
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.Stopped && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.MissedRunning
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.MissedStopped && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.AllMicroAlaram
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.MASevere && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.MAMinor
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.AllCargoCare && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.CCSevere
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.CCMinor && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.CCInformational
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.PowerOffNotReporting && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.PowerOffReporting
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.PowerOnNotReporting && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.PowerOnReporting
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.ChassisPwrInGeofence && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.ChassisPwrOutGeofence
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.ChassisNotPwrInGeofence && nextprops.statusFilter.StatusFilters[0] != ReeferAndGensetAndChassisStatusEnum.ChassisNotPwrOutGeofence) {
            if (!serverSideEnabled)
                this.setState({ rowData: nextprops.propsDryData });
            
        }
    }

    renderCustomerDeviceTypeSensorColumns() {
        columnDefs = this.createColumnDefs();
        var newColumns = columnDefs;
        //columnDefs2 = columnDefs;
        var generatedColumns = [];
        dryAssetSensors = this.props.customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'D');

        if (dryAssetSensors != null && dryAssetSensors != undefined && dryAssetSensors.length > 0) {
            //var door1Column = {
            //    headerName: "Door", field: "Door1Open", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, getQuickFilterText: DryFormatters.doorQuickFilterFormatter,
            //    filterParams: { valueGetter: params => { return DryFormatters.doorFormatterFilter(params); } },
            //    valueGetter: (params) => { return DryFormatters.DoorFormatterSorting(params); }, cellRenderer: DryFormatters.doorFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
            //};
            //generatedColumns.push(door1Column);

            $.each(dryAssetSensors, function (i, val) {
                var customerDeviceTypeSensorObject: any;
                if (val.SensorTypeCd.trim() == "T")
                    customerDeviceTypeSensorObject = { headerName: '', field: '', enableRowGroup: false, sortable: false, headerClass: val.OORText, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130, onCellClicked: self.onCellClickedCopy.bind(this) };
                else
                    customerDeviceTypeSensorObject = { headerName: '', field: '', refData: val.SensorSetDsc + "," + val.SensorResetDsc, enableRowGroup: false, sortable: false, headerClass: val.OORText, resizable: true, valueGetter: Formatters.stringTypeSortingForDigitalSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130, onCellClicked: self.onCellClickedCopy.bind(this) };

                //var fieldName = val.FieldValue;
                var columnHeaderName = val.ColumnNm;
                var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                customerDeviceTypeSensorObject.headerName = columnHeaderName;
                customerDeviceTypeSensorObject.field = columnFieldName;
                //customerDeviceTypeSensorObject.refData = val.SensorSetDsc + "," + val.SensorResetDsc;
                generatedColumns.push(customerDeviceTypeSensorObject);
            });

            var newColumnDefination = {
                headerName: "Device Sensor(s)",
                children: generatedColumns
            };
            if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                newColumns.push(newColumnDefination);
            this.setState({ columnDefs: newColumns });

            if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                columnDefs2.push(newColumnDefination);// = newColumns;
        }
        else {
            this.setState({ columnDefs: columnDefs });
        }
    }

    componentDidMount() {
        //console.log('didmount');
        //var columnDefs = this.createColumnDefs();
        //this.setState({ columnDefs: columnDefs });
        columnDefs2 = this.createColumnDefs();

        setTimeout(() => {
            this.renderCustomerDeviceTypeSensorColumns();
        }, 1000);

        //var functionID = 1;
        //var url = Config.ApiBaseUrl + '/api/User/GetDefaultSearchParams?FunctionId=' + functionID;
        //var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<server.UserPreferenceData>)
        //    .then(data => {
        //        if (data != null && data != undefined) {
        //            if (!data.DefaultSearch)
        //                this.props.requestDryAdvanceSearch(this.state.Filters);
        //        }
        //        else
        //            this.props.requestDryAdvanceSearch(this.state.Filters);
        //    });
        //this.props.requestReeferAdvanceSearch(this.state.Filters);
        self.setState({ tempFilters: this.state.Filters });
        $('.ag-column-hover').contextmenu(function (e) {
            var relX = e.pageX - $('.ag-column-hover').offset().left;
            var relY = (e.pageY - $('.ag-column-hover').offset().top);
            $(".drycontext-menu").toggle(100).css({
                top: relY,
                left: relX
            });
            $("#drycontextmenu").hide();
            $(".drycontext-menu").hide();
            e.preventDefault();
        });




        $(document).mousemove(function (event) {
            currentMousePos.x = event.pageX;
            currentMousePos.y = event.pageY;
            event.preventDefault();
        });
        Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
        Excel.draggableModalPopup(document.getElementById("contextMenuModelReport"));

    }

    onRefreshData = () => {
        $('#globalLoader').show();
        this.setState({
            rowData: this.state.rowData
        });

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }

        $('#globalLoader').hide();
    };

    /* WI 26971 implementation  start */
    static validateDryStatusHistoryMismatch(statusEventDttm: any, historyEventDttm: any) {
        IsTriggered = false;
        if (statusEventDttm != historyEventDttm)
            RCNGWindow.ConfirmWindow.showConfirmBox("New events are available for the Dry Status grid. Refresh now?", self.onRefreshDryStatusGrid.bind(this), self.onCancelRefreshDryStatusGrid.bind(this));
    }

    onCancelRefreshDryStatusGrid() {
        RCNGWindow.ConfirmWindow.close();
    }

    onRefreshDryStatusGrid() {
        if (!IsTriggered) {
            IsTriggered = true;
            RCNGWindow.ConfirmWindow.close();
            self.refreshDryStatusGridForNewEvents();
        }
    }

    refreshDryStatusGridForNewEvents() {
        selectedRowIndex = -1;
        this.setState({
            selectedItems: [],
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        }, () => this.DrySearchFilter(self.props.statusFilter, true, false, false));

    }
    /* WI 26971 implementation  end */

    onRowDataChanged(params: any): void {
        var containerIdSelected = "";
        if (self.state.IsCommandIssued && self.state.PrevSelectedItems.length > 0) {
            //var selItems = self.state.PrevSelectedItems;
            containerIdSelected = self.state.PrevSelectedItems[0].DCCurrentConditionID;
            // gensetIdSelected = "TEST0000540";
        }
        commandIssued = false;
        var TotalCount = 0;
        var PageSize = self.state.pageSize;
        var TempCount = 0;
        var gridData = self.state.rowData;
        if (gridData != null && gridData != undefined && gridData.length > 0) {
            TotalCount = gridData.length;
            params.api.setFunctionsReadOnly(false);
        } else {
            params.api.setFunctionsReadOnly(true);
        }

        if (TotalCount > 0 && containerIdSelected !== "") {
            let count = 0;
            if (containerIdSelected) {
                commandIssued = true;
                params.api.forEachNode((node) => {
                    count = count + 1;
                    if (node.data.DCCurrentConditionID === containerIdSelected) {
                        TempCount = count;
                        var pageNo = Math.ceil((TempCount / PageSize));
                        var setPageNum = pageNo - 1;
                        //console.log('pageNo' + pageNo);
                        params.api.paginationGoToPage(setPageNum);
                        var currentParent = node.parent;
                        while (currentParent) {
                            currentParent.setExpanded(true);
                            currentParent = currentParent.parent;
                        }
                        node.setExpanded(true);
                        node.setSelected(true);
                        self.setState({ IsCommandIssued: false });
                        return;
                    }
                })
            }
        }
    }

    UpdateIsCommandIssued(IsCmdIssued: any) {
        self.setState({ IsCommandIssued: IsCmdIssued });
    }
    UpdatePrevSelectedItems(prevSelectedItems: any) {
        self.setState({ PrevSelectedItems: prevSelectedItems });
    }

    createServerSideDatasource(server) {
        return {
            getRows: function (params) {

                setTimeout(function () {

                    params.success({
                        rowData: [],
                        rowCount: 0,
                    });
                    self.state.gridApiParams.showNoRowsOverlay(); // RCNG-5070 OMP QA2: "No Rows To Show" caption is not showing in all grids in dashboard
                }, 1000);
            },
        };
    }
    

    static ClearDryStatusGridData() {
        if (self != undefined) {
            //ReeferCallout.ResetMapPushpins();
            selectedRowIndex = -1;
            var datasource = self.createServerSideDatasource();
            self.state.gridApiParams.setServerSideDatasource(datasource);
            self.state.gridApiParams.showNoRowsOverlay();
            self.setState({
                rowData: [],
                loading: false
            });

            if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
                if (typeof self.state.gridApiParams.paginationGoToFirstPage() != "undefined")
                    self.state.gridApiParams.paginationGoToFirstPage();
            }
        }
    }


    dryContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Map": this.drymapAction(this.state.selectedItems);
                break;
            case "History": this.dryhistoryAction(this.state.selectedItems);
                break;
            case "CommandStatus": this.drycommandstatusAction(this.state.selectedItems);
                break;
            case "Details": this.drydetailsAction(this.state.selectedItems, 'Dry', 'CurrentDetails');
                break;
            case "Copy": this.drydetailsCopyAction();
                break;

        }
    }

    drydetailsCopyAction() {
        var result = this.copyToClipboard(coppiedData);
    }

    drydetailsCopyWithHeaderAction() {
        var result = this.copyToClipboard(coppiedDataWithHeader);
    }

    copyToClipboard(text) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    onCellClickedCopy(event) {
        //coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        //coppiedData = event.value;
        var isHistoryCall = false;
        var isHistorySelectionChanged = false; 
        if (this.state.selectedItems.length == 1 && previousDryid != event.data.AssetNumber)
            isHistorySelectionChanged = true;

        if ((selectedRowIndex != event.rowIndex) || (isHistorySelectionChanged == true)) {
            selectedRowIndex = event.rowIndex;
            isHistoryCall = true;
        }

        if (event.data != null && event.data != undefined) {
            self.props.getLastSelectedRow(event.data);
            //$('#globalLoader').show();
            if (event.colDef.headerName === "Comments" && event.value === 0)//RCNG-1110
                this.drydetailsAction(this.state.selectedItems, 'Dry', 'Comments');
            else if (isHistoryCall)
                DryHistoryGrid.ApplyDryHistorySearch(event.data, false, self.props.dryHistoryEnabled);
            //$("#globalLoader").hide();
        }
        if (this.state.selectedItems.length == 1) 
            previousDryid = event.data.AssetNumber;
    }

    drydetailsAction(data: any, dataSource: any, isOpenVia: any) {
        var drydetails = data;
        this.props.drydetailsAction(drydetails, dataSource, isOpenVia);
    }

    dryhistoryAction(data: any) {
        var drydetails = data;
        this.props.dryhistoryAction(drydetails);
    }

    drymapAction(data: any) {
        var drydetails = data;
        this.props.dryMapAction(drydetails);
    }

    drycommandstatusAction(data: any) {
        var drydetails = data;
        this.props.drycommandstatusAction(drydetails);
    }



    static SelectCurrentDry(currentReefer: any) {
        self.state.gridApiParams.deselectAll();
        DryHistoryGrid.ClearHistoryGridData();
        var countRecordPerPage = 0;
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode(function (node) {
            countRecordPerPage = countRecordPerPage + 1;
            if (node.data.AssetNumber === currentReefer.AssetNumber) {
                var currentPage = Math.trunc(countRecordPerPage / self.state.gridApiParams.paginationProxy.pageSize);
                if (currentPage > 1) {
                    self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.paginationGoToPage(currentPage);
                }

                node.setSelected(true);
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.ensureIndexVisible(node.rowIndex);
                self.setState({ selectedItems: node.data });
                self.props.getLastSelectedRow(node.data);
                //$('#globalLoader').show();
                DryHistoryGrid.ApplyDryHistorySearch(node.data, true, self.props.dryHistoryEnabled);
            }
        });
    }

    static SelectCurrentNode(currentReeferId: string) {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode(function (node) {
            if (node.data.AssetNumber === currentReeferId) {
                node.setSelected(true);
            }
        });
    }

    static ApplyDrySearchFilter(filters: server.ReeferSearchFilters, eventsRefresh: boolean, newSearch: any, loaderState: any) {
        if (self != undefined) {
            self.DrySearchFilter(filters, eventsRefresh, newSearch, loaderState);
        }
    }

    DrySearchFilter(filters: server.ReeferSearchFilters, eventsRefresh: boolean, newSearch: boolean, loaderState: boolean) {
        if (self != undefined) {
            $('#globalLoader').show();
            if (self.state.gridApiParams != null && self.state.gridApiParams != undefined) {
                if (typeof self.state.gridApiParams.showLoadingOverlay !== "undefined") {
                    //    self.state.gridApiParams.showLoadingOverlay();
                    //    self.state.gridApiParams.paginationGoToFirstPage();
                    //    self.state.gridApiParams.deselectAll();
                }
            }

            if (filters != null && filters != undefined) {
                var customAttributesInfo = {};
                var filterset: server.ReeferSearchFilters = {
                    SelectedOem: null, SelectedCountry: null, SelectedGeofence: null, SelectedGeofenceInside: null, SelectedInterval: null, SelectedReefer: null, SelectedAssetStates: null,
                    SelectedVesselCode: null, StatusFilters: [], AllReefers: null, CustomAttributeFilters: customAttributesInfo, SelectedAssetTypes: null, SelectedBookingNumber: null
                    , SelectedVesselCD: null, SelectedVoyage: null, SelectedCall: null, SelectedCargoCareProfiles: null, SelectedPod: null, SelectedPol: null, SelectedCTProfileIds: [] 
                };//WI-26881

                filterset.SelectedCountry = (filters.SelectedCountry == "" || filters.SelectedCountry == undefined) ? null : filters.SelectedCountry;
                filterset.SelectedGeofence = (filters.SelectedGeofence == "" || filters.SelectedGeofence == undefined) ? null : filters.SelectedGeofence;
                filterset.SelectedGeofenceInside = (filters.SelectedGeofenceInside == "" || filters.SelectedGeofenceInside == undefined) ? null : filters.SelectedGeofenceInside;
                filterset.SelectedInterval = (filters.SelectedInterval == "" || filters.SelectedInterval == undefined) ? null : filters.SelectedInterval;
                filterset.SelectedAssetTypes = (filters.SelectedAssetTypes == "" || filters.SelectedAssetTypes == undefined) ? null : filters.SelectedAssetTypes;
                filterset.SelectedAssetStates = (filters.SelectedAssetStates == "" || filters.SelectedAssetStates == undefined) ? null : filters.SelectedAssetStates;
                filterset.SelectedOem = (filters.SelectedOem == "" || filters.SelectedOem == undefined) ? null : filters.SelectedOem;
                filterset.SelectedReefer = (filters.SelectedReefer == "" || filters.SelectedReefer == undefined) ? null : filters.SelectedReefer;
                filterset.AllReefers = (filters.AllReefers == "" || filters.AllReefers == undefined) ? null : filters.AllReefers;
                filterset.SelectedVesselCode = (filters.SelectedVesselCode == "" || filters.SelectedVesselCode == undefined) ? null : filters.SelectedVesselCode;
                filterset.SelectedVesselCD = (filters.SelectedVesselCD == "" || filters.SelectedVesselCD == undefined) ? null : filters.SelectedVesselCD;//WI-26881
                filterset.SelectedVoyage = (filters.SelectedVoyage == "" || filters.SelectedVoyage == undefined) ? null : filters.SelectedVoyage;//WI-26881
                filterset.SelectedCall = (filters.SelectedCall == "" || filters.SelectedCall == undefined) ? null : filters.SelectedCall;//WI-26881
                filterset.StatusFilters = filters.StatusFilters;
                filterset.CustomAttributeFilters = filters.CustomAttributeFilters;
                self.setState({
                    tempFilters: filterset
                });

                var finalData = [];
                self.setState({ rowData: [], PrevStartRow: -1, PrevEndRow: -1 });
                var datasource = self.ServerSideDatasource(finalData, newSearch, loaderState);
                self.state.gridApiParams.setServerSideDatasource(datasource);
            }
        }

    }

    ServerSideDatasource(data: any, newSearch: any, loaderState: any) {
        return {
            getRows: (params) => {
                var newfilters: server.ReeferSearchFiltersSSRM = {
                    SelectedOem: self.state.tempFilters.SelectedOem,
                    SelectedCountry: self.state.tempFilters.SelectedCountry,
                    SelectedGeofence: self.state.tempFilters.SelectedGeofence,
                    SelectedGeofenceInside: self.state.tempFilters.SelectedGeofenceInside,
                    SelectedInterval: self.state.tempFilters.SelectedInterval,
                    SelectedReefer: self.state.tempFilters.SelectedReefer,
                    SelectedVesselCode: self.state.tempFilters.SelectedVesselCode,
                    StatusFilters: self.state.tempFilters.StatusFilters,
                    AllReefers: self.state.tempFilters.AllReefers,
                    CustomAttributeFilters: self.state.tempFilters.CustomAttributeFilters,
                    SelectedAssetTypes: self.state.tempFilters.SelectedAssetTypes,
                    SelectedAssetStates: self.state.tempFilters.SelectedAssetStates,
                    SelectedBookingNumber: self.state.tempFilters.SelectedBookingNumber,
                    StartRow: params.request.startRow,
                    EndRow: params.request.endRow,
                    RowGroupCols: params.request.rowGroupCols,
                    GroupKeys: params.request.groupKeys,
                    SortModels: params.request.sortModel,
                    SelectedVesselCD: self.state.tempFilters.SelectedVesselCD,
                    SelectedVoyage: self.state.tempFilters.SelectedVoyage,
                    SelectedCall: self.state.tempFilters.SelectedCall,
                    SelectedCargoCareProfiles: self.state.tempFilters.SelectedCargoCareProfiles,
                    SelectedPod: self.state.tempFilters.SelectedPod,
                    SelectedPol: self.state.tempFilters.SelectedPol,
                    SelectedCTProfileIds: self.state.tempFilters.SelectedCTProfileIds
                };
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/asset/GetDCCurrentConditionDataSP', { method: 'POST', body: JSON.stringify(newfilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
                let fetchTask = fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<any[]>)
                    .then(finalData => {
                        var response:any = this.getData_old(finalData, params.request, newSearch);
                        if (response.rows.length == 0) {
                            self.state.gridApiParams.showNoRowsOverlay();
                        }
                        else {
                            self.state.gridApiParams.hideOverlay();
                        }
                        setTimeout(function () {
                            if (response.success) {                                
                                params.successCallback(response.rows, response.lastRow);
                                if(!loaderState)
                                    $('#globalLoader').hide();
                            } else {
                                params.failCallback();
                            }
                        }, 200);
                    });

            },
        };
    };


    getData_old(params, req, newSearch) {
        if(req.startRow != 0 && newSearch == true)
            newSearch = false;    
        var newData = params;
        let dryData = cloneDeep(params);
        //let reefersData = Object.assign({}, params);
        var dryStateData = self.state.rowData;
        //if (req.endRow != reeferStateData.length && req.endRow > reeferStateData.length && params.length != reeferStateData.length) {
        if (req.endRow != dryStateData.length && req.endRow > dryStateData.length && req.endRow != this.state.PrevEndRow) {
            dryData.push(...dryStateData);
            self.setState({ rowData: dryData, PrevEndRow: req.endRow, PrevStartRow: req.startRow }, () => {
                if(!newSearch)
                    ReeferCallout.BindClusterMapPushpins(self.state.rowData, 'dry', self.state.reeferFormatter);
            });
        }
        else {
            if(!newSearch)
                ReeferCallout.BindClusterMapPushpins(self.state.rowData, 'dry', self.state.reeferFormatter);
        }

        return {
            success: true,
            rows: newData,
            lastRow: this.getLastRowIndex(req, newData),//params.length,//getLastRowIndex(req, newData),
        };
    }

     getLastRowIndex(request, results) {
        if (!results || results.length === 0) {
            return request.startRow;
        }
        if (self.state.rowData.length == request.endRow || (parseInt(self.state.rowData.length) % parseInt(self.state.pageSize) == 0)) {
            var currentLastRow = request.startRow + results.length+1;
        } else {
            var currentLastRow = request.startRow + results.length;
        }

        return currentLastRow <= request.endRow ? currentLastRow : -1;
    }   

    static refreshGridReady(dashboardWidgetsSearch: any) {
        var gridPreferencesData: any = dashboardWidgetsSearch.filter(x => x.DashboardWidgetId == 16);
        var defaultColumns = self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "DryStatusGrid");
        }, 3000);
    }

    
    onGridReadyServer(params: any) {
        var totalWidgetSearch = self.props.totalWidgetSearch;//WI26412
        $('#globalLoader').show();
        //this.gridApi.sizeColumnsToFit();
        self.setState({ gridApiParams: params.api });
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x => x.DashboardWidgetId == 16);
        //params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        $('#globalLoader').hide();
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, params.api, gridPreferencesData, "DryStatusGrid");
        }, 3000);
        //GridPreferenceControl.StatusGridPreferenceColumns(functionId, params.api, "ReeferStatusGrid");
        var finalData = [];
        var filterDefault: server.ReeferSearchFilters = {
            SelectedCountry: "", SelectedAssetTypes: "", SelectedAssetStates: "", SelectedGeofence: "", SelectedGeofenceInside: "", SelectedInterval: "", SelectedOem: "", SelectedReefer: "", SelectedVesselCode: "", StatusFilters: [12], CustomAttributeFilters: {}, AllReefers: "", SelectedBookingNumber: null, SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: []  //WI-26881
        };
        var filterDefault2: server.ReeferSearchFilters = {
            SelectedCountry: "", SelectedAssetTypes: "", SelectedAssetStates: "", SelectedGeofence: "", SelectedGeofenceInside: "", SelectedInterval: "", SelectedOem: "", SelectedReefer: "", SelectedVesselCode: "", StatusFilters: [12], CustomAttributeFilters: {}, AllReefers: null, SelectedBookingNumber: null, SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: []  //WI-26881
        };
        //if condition added for WI26412
        if (totalWidgetSearch) {
            var hasDryFilter = self.props.statusFilter.SelectedAssetTypes;
            if (hasDryFilter != null && hasDryFilter != undefined && hasDryFilter.length > 0) {
                var regexp = /Dry/gi;
                if (hasDryFilter.search(regexp) == -1) {
                    // console.log("Does not contain Dry");
                } else {
                    if (self.props.hasDry) {
                        let isEquals = isEqual(filterDefault, self.props.statusFilter);
                        if (!isEquals) {
                            var datasource = self.ServerSideDatasource(finalData, false, false);
                            params.api.setServerSideDatasource(datasource);
                        }
                    }
                }
            } else {
                let isEquals = isEqual(filterDefault2, self.props.statusFilter);
                if (!isEquals) {
                    var datasource = self.ServerSideDatasource(finalData, false, false);
                    params.api.setServerSideDatasource(datasource);
                }

            }
        }
        /* WI 26568 changes start */
        else {
            if (self.props.propsDryData != null && self.props.propsDryData != undefined && self.props.propsDryData.length > 0) {
                var datasource = self.ServerSideDatasource(finalData, false, false);
                params.api.setServerSideDatasource(datasource);
            }
            else {
                var datasource = self.createServerSideDatasource();
                self.state.gridApiParams.setServerSideDatasource(datasource);
              
            }
        }
        /* WI 26568 changes end */
    }

    static ClearSelection() {
        $('#globalLoader').show();
        selectedRowIndex = -1;
        //DryHistoryGrid.ClearHistoryGridData();
        //this.props.clearGridHeaderExtension();
        if (self != undefined) {
            self.state.gridApiParams.deselectAll();
        }
        //ReeferCallout.BindClusterMapPushpins(this.state.rowData, 'dry', self.state.reeferFormatter);
        $('#globalLoader').hide();
    }
    onGridScroll(params: any) {
        $(".drycontext-menu").hide();
        $("#drycontextmenu").hide();
    }

    onGridPaginationChanged(params: any) {
        if (params.newPage) {
            self.props.clearGridHeaderExtension();
            if (!commandIssued)
                params.api.deselectAll();
            commandIssued = false;
            DryHistoryGrid.ClearHistoryGridData();
            //ReeferCallout.BindClusterMapPushpins(this.state.rowData, 'status');
        }

        //if (params.api.getDisplayedRowCount() == 1) {
        //    var rowindex = 0;
        //    var rowNode = params.api.getRowNode(rowindex);
        //    // do something with the row, eg select it
        //    if (rowNode != undefined && rowNode != null) {
        //        rowNode.setSelected(true);
        //        DryHistoryGrid.ApplyDryHistorySearch(rowNode.data, false);
        //    }
        //}
    }

    italicizeGridRows(params: any) {
        if (params.data != null && params.data != undefined) {
            if (params.data.EventDTTM != params.data.DeviceDataTime)
                return { 'font-style': 'italic' }
        }
    }
    onSort(params: any) {
        params.api.clearFocusedCell();
        this.clearGridRowSelection(params);
    }
    onGridSelectionChanged(params: any) {
        $("#drycontextmenu").show();
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            //var selected = params.api.getFocusedCell();
            //var selectedRow = params.api.getRowNode(selected.rowIndex);
            //ReeferCallout.ResetMapPushpins(); // Clear existing pushpins
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
                //ReeferHistoryGrid.ApplyReeferHistorySearch(selectedRow);
            });
            //var selectedItems = self.state.selectedItems;
            self.setState({
                selectedItems: selectedReeferData,
                isChangeDeforstInterval: false,
                pretripCmd: null,
                modelTitle: '',
                popUpHtml: ''
            });
            self.props.getSelectedRow(selectedRows);
            //self.props.getLastSelectedRow(selectedRow.data);
            //$('#globalLoader').show();
            //ReeferHistoryGrid.ApplyReeferHistorySearch(selectedRow.data);
            //$("#gensetcontextmenu").show();

            //var selectedItems = self.state.selectedItems;
            self.setState({
                selectedItems: selectedReeferData,
                isChangeDeforstInterval: false,
                pretripCmd: null,
                modelTitle: '',
                popUpHtml: ''
            });

            //if (selectedReeferData.length > 1) {
            //    $('#liDetailsRequiresRight').removeClass('enabled');
            //    $('#liDetailsRequiresRight').addClass('disabled');
            //    //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('enabled');
            //    //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('disabled');
            //}
            //else {
            //    $('#liDetailsRequiresRight').removeClass('disabled');
            //    $('#liDetailsRequiresRight').addClass('enabled');
            //    //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('disabled');
            //    //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('enabled');
            //}
            //var forwardCommandParam = JSON.stringify(selectedReeferData);
            //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetAssetAssigned3rdParty';
            //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParam, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //fetch(request)
            //    .then(RCUtils.handleError)
            //    .then(response => response.json() as Promise<string>)
            //    .then(data => {
            //        if (data == "assigned") {
            //            if ($("#liThirdPartyAccessRequiresRightDry").hasClass("show")) $('#liThirdPartyAccessRequiresRightDry').removeClass('disabled');
            //            if ($("#liThirdPartyAccessRequiresRightDry").hasClass("show")) $('#liThirdPartyAccessRequiresRightDry').addClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRightDry").hasClass("show")) $('#liUnassignFromCustomerRequiresRightDry').removeClass('disabled');
            //            if ($("#liUnassignFromCustomerRequiresRightDry").hasClass("show")) $('#liUnassignFromCustomerRequiresRightDry').addClass('enabled');
            //            if ($("#liAssignToCustomerRequiresRightDry").hasClass("show")) $('#liAssignToCustomerRequiresRightDry').removeClass('enabled');
            //            if ($("#liAssignToCustomerRequiresRightDry").hasClass("show")) $('#liAssignToCustomerRequiresRightDry').addClass('disabled');

            //        }
            //        else if (data == "unassigned") {
            //            if ($("#liThirdPartyAccessRequiresRightDry").hasClass("show")) $('#liThirdPartyAccessRequiresRightDry').removeClass('disabled');
            //            if ($("#liThirdPartyAccessRequiresRightDry").hasClass("show")) $('#liThirdPartyAccessRequiresRightDry').addClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRightDry").hasClass("show")) $('#liUnassignFromCustomerRequiresRightDry').removeClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRightDry").hasClass("show")) $('#liUnassignFromCustomerRequiresRightDry').addClass('disabled');
            //            if ($("#liAssignToCustomerRequiresRightDry").hasClass("show")) $('#liAssignToCustomerRequiresRightDry').removeClass('disabled');
            //            if ($("#liAssignToCustomerRequiresRightDry").hasClass("show")) $('#liAssignToCustomerRequiresRightDry').addClass('enabled');
            //        }
            //        else {
            //            if ($("#liThirdPartyAccessRequiresRightDry").hasClass("show")) $('#liThirdPartyAccessRequiresRightDry').removeClass('enabled');
            //            if ($("#liThirdPartyAccessRequiresRightDry").hasClass("show")) $('#liThirdPartyAccessRequiresRightDry').addClass('disabled');
            //            if ($("#liUnassignFromCustomerRequiresRightDry").hasClass("show")) $('#liUnassignFromCustomerRequiresRightDry').removeClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRightDry").hasClass("show")) $('#liUnassignFromCustomerRequiresRightDry').addClass('disabled');
            //            if ($("#liAssignToCustomerRequiresRightDry").hasClass("show")) $('#liAssignToCustomerRequiresRightDry').removeClass('enabled');
            //            if ($("#liAssignToCustomerRequiresRightDry").hasClass("show")) $('#liAssignToCustomerRequiresRightDry').addClass('disabled');
            //        }
            //    });
        }

    }


    static ReeferStatusResult() {
        self.DrySearchFilter(self.state.tempFilters, false, false, false);
    }
    HideAllContextMenus() {
        $("#gensetcontextmenu").hide();
        $(".gensetcontext-menu").hide();
        $("#drycontextmenu").hide();
        $(".drycontext-menu").hide();
        $("#chassiscontextmenu").hide();
        $(".chassiscontext-menu").hide();
        $("#contextmenu").hide();
        $(".context-menu").hide();
    }

    copyRowsToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: false });//RCNG-225
    }

    copyRowsWithHeadersToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: true });//RCNG-225
    }

    getDryContextMenuItems = params => {
        //TODO : after test uncommnet below line
        //RCUtils.HighlightCurrentGridRow(params,"DCCurrentConditionID",self.state.selectedItems);
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
                coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                //var dCCurrentConditionID = selectedrowNode.data.DCCurrentConditionID;
                var assetMasterID = selectedrowNode.data.AssetMasterID;
                params.api.forEachNode((newRowNode, index) => {
                    if ((newRowNode.data.AssetMasterID === assetMasterID)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.AssetMasterID == selectedrowNode.data.AssetMasterID) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            var result = [
                {
                    name: 'Copy',
                    subMenu: [
                        {
                            name: 'Copy Cell',
                            action: () => {
                                //this.reeferContextMenuClick("Copy");
                                var cellContent = this.ProcessCellForClipboard(params);
                                params.api.clipboardService.copyDataToClipboard(cellContent);

                            }
                        },
                        {
                            name: 'Copy Row(s)',
                            action: () => {
                                this.copyRowsToClipBoard();
                            }
                        },
                        {
                            name: 'Copy Row(s) with Headers',
                            action: () => {
                                this.copyRowsWithHeadersToClipBoard();
                            }
                        },
                    ],
                },
                //'copy',
                //'copyWithHeaders',
                {
                    name: 'Map',
                    action: () => {
                        this.dryContextMenuClick("Map");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('162'),
                },
                {
                    name: 'Current Details',
                    action: () => {
                        this.dryContextMenuClick("Details");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('159'),
                    disabled: UserRights.checkMenuItemDisabledForDry(params, 'CurrentDetails'),
                },
                {
                    name: 'History',
                    action: () => {
                        this.dryContextMenuClick("History");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('163'),
                },
                {
                    name: 'Third Party Access',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('170,171'),
                    disabled: UserRights.checkMenuItemDisabledForDry(params, 'ThirdPartyAccess'),
                    subMenu: [
                        {
                            name: 'Assign / Edit',
                            action: () => {
                                this.popUpAssignToCustomer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('170'),
                            disabled: UserRights.checkMenuItemDisabledForDry(params, 'Assign'),
                        },
                        {
                            name: 'Unassign From Customer',
                            action: () => {
                                this.popUpUnAssignFromCustomer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('171'),
                            disabled: UserRights.checkMenuItemDisabledForDry(params, 'UnAssign'),
                        },
                    ],
                },
                {
                    name: 'Inventory',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('250,251'),//RCNG-1176
                    disabled: UserRights.checkMenuItemDisabled(params, 'RetireOrReactivate'),
                    subMenu: [
                        {
                            name: 'Retire',
                            action: () => {
                                this.popUpRetire();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleInventory('250', params, "Retire"),
                        },
                        {
                            name: 'Reactivate',
                            action: () => {
                                this.popUpReactivate();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleInventory('251', params, "Reactivate"),
                        },
                    ],
                },
                'separator',
                {
                    name: 'Export',
                    action: () => {
                        this.popUpExport();
                    },
                },
                {
                    name: 'Send Email',
                    action: () => {
                        this.popUpSendEmail();
                    },
                },
            ];
            return result;
        }
    };

    //getDryContextMenuItems(params: any) {
    //    var flag = false;
    //    var selected = params.api.getFocusedCell();

    //    var setRowIndex = selected.rowIndex;
    //    var row = params.api.getDisplayedRowAtIndex(setRowIndex);
    //    if (row != null && row != "undefined" && !row.group) {
    //        var rowId = row.id;
    //        var selectedrowNode = params.api.getRowNode(rowId);
    //        //var selectedrowNode = params.api.getRowNode(setRowIndex);
    //        //var tempArray = [];// if sort is clicked save in temp array
    //        //params.api.forEachNode(function (rowNode, index) {
    //        //    tempArray.push(rowNode);
    //        //});

    //        //var resortitem = tempArray[setRowIndex];
    //        var sortflage = false;
    //        //var reeferid = resortitem.data.ReeferID;
    //        var dCCurrentConditionID = selectedrowNode.data.DCCurrentConditionID;
    //        params.api.forEachNode(function (NewrowNode, index) {
    //            if ((NewrowNode.data.DCCurrentConditionID === dCCurrentConditionID)) {
    //                selectedrowNode = NewrowNode;
    //                return false;
    //            }
    //        });
    //        $.each(self.state.selectedItems, function (index, item) {
    //            if (item.DCCurrentConditionID == selectedrowNode.data.DCCurrentConditionID) {
    //                flag = true;
    //                return false;
    //            }
    //        });
    //        if (!flag)
    //            params.api.deselectAll();
    //        selectedrowNode.setSelected(true);
    //    }
    //    /*var selectedrowNode = params.api.getRowNode(selected.rowIndex);
    //    var tempArray = [];// if sort is clicked save in temp array
    //    params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
    //        tempArray.push(rowNode);
    //    });

    //    var resortitem = tempArray[selected.rowIndex];
    //    var dCCurrentConditionID = resortitem.data.DCCurrentConditionID;
    //    params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
    //        if ((NewrowNode.data.DCCurrentConditionID === dCCurrentConditionID)) {
    //            selectedrowNode = NewrowNode;
    //            return false;
    //        }
    //    });

    //    $.each(self.state.selectedItems, function (index, item) {
    //        if (item.DCCurrentConditionID == selectedrowNode.data.DCCurrentConditionID) {
    //            flag = true;
    //            return false;
    //        }
    //    });

    //    if (!flag)
    //        params.api.deselectAll();

    //    //$(".drycontext-menu").show(); $("#drycontextmenu").show();
    //    //Excel.preventDefault();
    //    params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
    //    */
    //    $(document).contextmenu(function (e) {
    //        self.HideAllContextMenus(); // landing page have multiple context menus close all
    //        var divmenuwidth = 390;
    //        var offset = $("#DRY-grid .ag-column-hover").offset();
    //        if ((typeof (offset) != 'undefined') && offset != null) {
    //            if (offset.left > 400) {
    //                divmenuwidth = 390;
    //            } else if (offset.left > 890) {
    //                divmenuwidth = 690;
    //            } else {
    //                divmenuwidth = 40;
    //            }
    //        }
    //        /// var relativeX = (e.pageX - offset.left);
    //        if ((typeof (offset) != 'undefined') && offset != null) {
    //            var relativeY = (e.pageY - offset.top + 50);
    //        }
    //        var relativeX = e.pageX - divmenuwidth;

    //        if (relativeX > ($(window).width() - (divmenuwidth + 5))) {
    //            relativeX = relativeX - (divmenuwidth + 5);
    //        }
    //        var height = $(window).height() - 200;
    //        var halfheight = ($(window).height()) / 2;
    //        if (height < relativeY) {
    //            relativeY = (relativeY - halfheight) + 20;
    //        }
    //        $(".drycontext-menu").css({
    //            top: relativeY + "px",
    //            left: relativeX + "px",
    //            position: "absolute"
    //        });
    //    });


    //    $("#DRY-grid .ag-cell").unbind("contextmenu");
    //    $("#DRY-grid .ag-cell").bind('contextmenu', function (e) {
    //        var flag = false;
    //        var selected = params.api.getFocusedCell();

    //        var setRowIndex = selected.rowIndex;
    //        var row = params.api.getDisplayedRowAtIndex(setRowIndex);
    //        if (row != null && row != "undefined" && !row.group) {
    //            var rowId = row.id;
    //            var selectedrowNode = params.api.getRowNode(rowId);
    //            //var selectedrowNode = params.api.getRowNode(setRowIndex);
    //            //var tempArray = [];// if sort is clicked save in temp array
    //            //params.api.forEachNode(function (rowNode, index) {
    //            //    tempArray.push(rowNode);
    //            //});

    //            //var resortitem = tempArray[setRowIndex];
    //            var sortflage = false;
    //            //var reeferid = resortitem.data.ReeferID;
    //            var dCCurrentConditionID = selectedrowNode.data.DCCurrentConditionID;
    //            params.api.forEachNode(function (NewrowNode, index) {
    //                if ((NewrowNode.data.DCCurrentConditionID === dCCurrentConditionID)) {
    //                    selectedrowNode = NewrowNode;
    //                    return false;
    //                }
    //            });
    //            $.each(self.state.selectedItems, function (index, item) {
    //                if (item.DCCurrentConditionID == selectedrowNode.data.DCCurrentConditionID) {
    //                    flag = true;
    //                    return false;
    //                }
    //            });
    //            if (!flag)
    //                params.api.deselectAll();
    //            selectedrowNode.setSelected(true);
    //        }

    //        /*var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
    //        var tempArray = [];// if sort is clicked save in temp array
    //        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
    //            tempArray.push(rowNode);
    //        });
    //        var resortitem = tempArray[selected.rowIndex];  
    //        var sortflage = false;
    //        var dCCurrentConditionID = resortitem.data.DCCurrentConditionID;
    //        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
    //            if ((NewrowNode.data.DCCurrentConditionID === dCCurrentConditionID)) {
    //                selectedrowNode = NewrowNode;
    //                return false;
    //            }
    //        });
    //        $.each(self.state.selectedItems, function (index, item) {
    //            if (item.DCCurrentConditionID == selectedrowNode.data.DCCurrentConditionID) {
    //                flag = true;
    //                return false;
    //            }
    //        });
    //        if (!flag)
    //            params.api.deselectAll();
    //        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
    //        */
    //        var reSized = self.props.isResizeClicked;
    //        if (JSON.stringify(reSized) === 'false') {
    //            var divmenuwidth = 280;
    //        } else {
    //            var divmenuwidth = 20;
    //        } 
    //        var offset = $("#DRY-grid .ag-column-hover").offset();
    //        var relativeY = (e.pageY - offset.top);
    //        var relativeX = e.pageX - divmenuwidth;

    //        if (relativeX > ($(window).width() - (divmenuwidth + 5))) {
    //            relativeX = relativeX - (divmenuwidth + 5);
    //        }
    //        var height = $(window).height();
    //        var halfheight = ($(window).height()) / 2;
    //        //if ((window as any).clipboardData) {
    //        //    if (height < relativeY + 560) {
    //        //        //if IE Browser 
    //        //        relativeY = (relativeY - 150);
    //        //    }
    //        //}
    //        //else
    //        if (JSON.stringify(reSized) === 'false') {
    //            // click on below window half height make to Y top to static value 140px
    //            if (relativeY > 140) {
    //                relativeY = 140;
    //            }
    //        } else {
    //            var height = $(window).height() - 200;
    //            var halfheight = ($(window).height()) / 2;
    //            if ((window as any).clipboardData) {
    //                if (height < relativeY + 60) {
    //                    //if IE Browser 
    //                    relativeY = (relativeY - 150);
    //                }
    //            }
    //            else if (height < relativeY + 378) {
    //                relativeY = (relativeY - 135);
    //            }
    //        }
    //        $(".drycontext-menu").css({
    //            top: relativeY + "px",
    //            left: relativeX + "px",
    //            position: "absolute"
    //        });
    //        $("#drycontextmenu").show();
    //        $(".drycontext-menu").show();
    //        e.preventDefault();
    //        return false;
    //    });

    //    $(document).contextmenu(function () {
    //        return false;
    //    });

    //    $(document).bind('drycontextmenu click', function () {
    //        $(".drycontext-menu").hide();
    //    });

    //    $('.drycontext-menu').bind('drycontextmenu', function () {
    //        return false;
    //    });
    //    $('.drycontext-menu').on('click', 'li', function () {
    //        $(".drycontext-menu").hide();
    //    });
    //}
    onCancelDryStatusGrid() {
        RCNGWindow.ConfirmWindow.close();
    }
    popUpRetire() {
        IsTriggered = false;
        RCNGWindow.ConfirmWindow.showConfirmBox("By default, a retired asset does not appear in search results, nor does it contribute to the information collected by most dashboard widgets. Continue?",
            self.onYesRetire.bind(this),
            self.onCancelDryStatusGrid.bind(this));
    }
    popUpReactivate() {
        IsTriggered = false;
        RCNGWindow.ConfirmWindow.showConfirmBox("By default, a reactivated asset appears in search results and contributes to the information collected by most dashboard widgets. Continue?",
            self.onYesReactivate.bind(this),
            self.onCancelDryStatusGrid.bind(this));
    }
    onYesRetire() {
        if (!IsTriggered) {
            IsTriggered = true;
            var commandUnits = this.getForwardCommandUnits();
            RCNGWindow.ConfirmWindow.close();
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/asset/RetireAsset', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    $('#globalLoader').hide();
                    if (result === "success") {
                        PopupWindow.showErrorMessage("Alert", "Asset(s) Retired.");
                        self.refreshStatusGrid();
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Error Occured.");
                    }
                });
        }
    }
    onYesReactivate() {
        if (!IsTriggered) {
            IsTriggered = true;
            var commandUnits = this.getForwardCommandUnits();
            $('#globalLoader').show();
            RCNGWindow.ConfirmWindow.close();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/asset/ReactivateAsset', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    $('#globalLoader').hide();
                    if (result === "success") {
                        PopupWindow.showErrorMessage("Alert", "Asset(s) Reactivated.");
                        self.refreshStatusGrid();

                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Error Occured.");
                    }
                });
        }
    }

    getForwardCommandUnits() {
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var commandUnits = [];

        if (this.state.selectedItems.length > 0) {
            forEach(this.state.selectedItems, function (value, key) {
                var commandUnitObject = {
                    "AssetMasterID": value.AssetMasterID,
                    "AssetNumber": value.AssetNumber,
                    "RCDMasterID": value.RCDMasterID,
                    //"DCCurrentConditionID": value.DCCurrentConditionID,
                    //"DCConditionID": value.DCConditionID,
                    "RCDID": value.RCDID,
                    "VesselCd": value.VesselCd
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }
    defaultColDef() {
        return [{
            flex: 1,
            minWidth: 100,
            filter: false,
            sortable: false,
            enableRowGroup: false,
            resizable: true,
        }]
    }

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: 'State Indicators',
                children: [
                    {
                        headerName: "PWR", field: "DryPWR", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, width: 70,
                        valueGetter: (params) => { return DryFormatters.dryPWRSorting(params); },
                        filterParams: { valueGetter: params => { return DryFormatters.dryPwrStateFormatterFilter(params); } },
                        cellRenderer: DryCellRenderer.PwrStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "BATT", field: "BatteryPct", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return DryFormatters.dryBatteryPctSorting(params); },
                        filterParams: { valueGetter: params => { return DryFormatters.dryBatteryPctFormatterFilter(params); } },
                        cellRenderer: DryCellRenderer.BatteryPctFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "VSL", field: "VesselCd", width: 80, enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselCd"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "INV", field: "AssetState", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetState"); }, cellRenderer: DryCellRenderer.AssetStateFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: 'Assignments',
                children: [
                    {
                        headerName: "Assigned to", field: "customername", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.customername); },
                        cellRenderer: DryCellRenderer.StringTypeFormatterFor3P, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
                    }
                ]
            },
            {
                headerName: 'Identification',
                children: [
                    { headerName: "Dry ID", field: "AssetNumber", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetNumber"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                ]
            },
            {
                headerName: "Report Date/Time and Location",
                children: [

                    { headerName: "Event", field: "EventDescription", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EventDescription"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, enableTooltip: true, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", enableRowGroup: false, cellClass: 'myExcelStyle',
                        sortable: true, filter: false,
                        filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } }, resizable: true, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "EventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Door", field: "Door1Open", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, getQuickFilterText: DryFormatters.doorQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return DryFormatters.doorFormatterFilter(params); } },
                        valueGetter: (params) => { return DryFormatters.DoorFormatterSorting(params); }, cellRenderer: DryFormatters.doorFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Door time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "Door1EventDttm", enableRowGroup: false, cellClass: 'myExcelStyle',
                        sortable: false, filter: false, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDoorEventDtmForFilter(params); } },
                        valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "Door1EventDttm"); }, cellRenderer: Formatters.dateTypeFormatter, width: 170,
                        onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Inside temp ", field: "InsideTemp", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "InsideTemp"); }, cellRenderer: DryFormatters.TemperatureValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Possible damage", field: "PossibleDamage", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PossibleDamage"); }, cellRenderer: DryCellRenderer.PossibleDamageFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device fence", field: "FenceName", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FenceName"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device fence ID", field: "FenceNameID", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FenceNameID"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Server fence", field: "BackendGeofenceName", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BackendGeofenceName"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Server fence ID", field: "BackendGeofenceNameID", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BackendGeofenceNameID"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    // { headerName: "Region Fence", field: "RegionGeofence", cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    // { headerName: "Region Fence ID", field: "RegionGeofenceName", cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Geofence revision", field: "GeofenceDefinitionRevision", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "GeofenceDefinitionRevision"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Address", field: "Address", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Address"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), columnGroupShow: 'open', cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "City", field: "City", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "City"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "State", field: "State", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "State"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Country", field: "Country", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Country"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Zip", field: "ZipCode", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ZipCode"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    //{ headerName: "Battery (V)", field: "DeviceBattery", cellRenderer: Formatters.BattVoltageFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)},
                    {
                        headerName: "Loc coords", field: "GPSCoords", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: DryCellRenderer.GPSCoordsFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.secondsToTimeConverterFilter(params); },
                        filterParams: { valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); } },
                        width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Loc acc (m)", field: "PositionAccuracy", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSAcctypeSorting(params.data.PositionAccuracy); },
                        cellRenderer: DryCellRenderer.StringTypeValueFormatter,
                        columnGroupShow: 'open', width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Loc HDOP", field: "DryGPSHDOP", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSHDOPTypeSorting(params.data.DryGPSHDOP, params.data.GPSLockState); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter,
                        columnGroupShow: 'open', width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Loc sat ct", field: "DryGPSSatelliteCount", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSSatCountTypeSorting(params.data.DryGPSSatelliteCount, params.data.GPSLockState); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter,
                        columnGroupShow: 'open', width: 70, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Speed", field: "DrySpeed", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        headerValueGetter: Formatters.SpeedHeaderFormatter,
                        valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "DrySpeed"); }, cellRenderer: DryFormatters.SpeedConverter,
                        filterParams: { valueGetter: params => { return DryFormatters.SpeedConverterFilter(params); } },
                        columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Miles", field: "Miles", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "Miles"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    }

                ]
            },
            {
                headerName: "Device Status",
                children: [
                    {
                        headerName: "Device ID", field: "RCDID", enableRowGroup: false, sortable: true, filter: false, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => {
                            return Formatters.stringTypeSortingFieldName(params, "RCDID");
                        }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device data", headerValueGetter: Formatters.TimeZoneHeaderFormatter, columnGroupShow: 'open',
                        field: "DeviceDataTime", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DeviceDataTime"); }, cellRenderer: Formatters.dateTypeFormatter,
                        filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDeviceDataTimeForFilter(params); } },
                        width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device FW", field: "FirmwareVersion", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FirmwareVersion"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device temp ", field: "DeviceTemp", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DeviceTemp"); }, cellRenderer: DryFormatters.TemperatureValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device bat (V)", field: "BattVoltage", enableRowGroup: false, cellClass: 'bigInt', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.BattVoltageSorting(params.data.BattVoltage); },
                        filterParams: { valueGetter: params => { return Formatters.DeviceBattVoltageFormatterForFilter(params); } }, cellRenderer: Formatters.BattVoltageValueFormatter,
                        columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Lux", field: "Illumination", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Illumination"); }, cellRenderer: Formatters.LuxValueFormatter, width: 70
                    },
                    {
                        headerName: "Bat mode", field: "BatteryMode", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.BatteryModeFormatter(params); },
                        filterParams: { valueGetter: params => { return DryFormatters.BatteryModeFormatterFilter(params); } },
                        cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Door bat", field: "Door1BattPct", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return DryFormatters.dryDoorBattPctSorting(params); },
                        filterParams: { valueGetter: params => { return DryFormatters.dryDoorBattPctFormatterFilter(params); } },
                        cellRenderer: DryCellRenderer.DoorBattPctFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                                        {
                        headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDReportingInterval"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 180, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "MSISDN", field: "MSISDN", enableRowGroup: false, sortable: false, filter: false, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MSISDN"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: false, sortable: false, filter: false, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SIM_IMSI"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "ICCID", field: "ICCID", enableRowGroup: false, sortable: false, filter: false, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ICCID"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "EUI", field: "EUI", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EUI"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Cell signal", field: "RSSI", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return Formatters.RSSISorting(params); },
                        cellRenderer: DryCellRenderer.RSSITypeFormatter,
                        filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } },
                        width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "MCC (country)", field: "CountryName", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CountryName"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "MNC", field: "MNC", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MNC"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerLocalizationAreaCode"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: false, sortable: false, filter: false, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerBaseStationID"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Cell gen", field: "CellNetGeneration", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CellNetGeneration"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device type", field: "DeviceType", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DeviceType"); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                ]
            },
            {
                headerName: "Misc.",
                children: [
                    {
                        headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CreatedDTTM",
                        enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "CreatedDTTM"); }, cellRenderer: Formatters.dateTypeFormatter,
                        filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterCreatedDTTMForFilter(params); } },
                        width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Comments", field: "CommentExistsDC", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true,
                        valueGetter: (params) => { return DryFormatters.CommentExistsforDrySorting(params); }, cellRenderer: DryCellRenderer.CommentExistsFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    }
                ]
            },

            {
                headerName: "Device Gravity Vector Status",
                children: [
                    {
                        headerName: "X Axis", field: "XAxis", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "XAxis"); }, cellRenderer: Formatters.GravityVectorValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Y Axis", field: "YAxis", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "YAxis"); }, cellRenderer: Formatters.GravityVectorValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Z Axis", field: "ZAxis", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ZAxis"); }, cellRenderer: Formatters.GravityVectorValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    }
                ]
            }

        ];


    }

    clearGridRowSelection(params: any) {
        self.props.renderClearSelection();
        params.api.deselectAll();
    }
    columnRowGroupChanged(params: any) {
        self.clearGridRowSelection(params);
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    onSaveGridRowGroupState(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = currentGropup;
                    selectedColumnIds = preferenceData.SelectedColumnIds;
                    selectedColumnValues = preferenceData.SelectedColumnValues;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
                else {
                    // if no userpreference record in db 
                    rowGroupItems = currentGropup;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    // var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var rowGroupDataToSave = { colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(rowGroupDataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });

                }
            });

        //var maxRowGroupLimit = 4;
        //var current = params.columns.length;

        //if (current === maxRowGroupLimit) {

        //    groupingDisabled = true;
        //    PopupWindow.showErrorMessage("RowGroup!", "max limit reached, please remove a group before adding a new one");

        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: false };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
        //if (current < maxRowGroupLimit && groupingDisabled) {
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: true };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
    }

    refreshStatusGrid() {
        selectedRowIndex = -1;
        this.props.clearGridHeaderExtension();
        DryHistoryGrid.ClearHistoryGridData();
        this.setState({
            selectedItems: [],
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        });
        setTimeout(() => {
            this.DrySearchFilter(self.props.statusFilter, false, false, false);
        }, 200);
        //ReeferStatusGrid.ApplyReeferSearchFilter(self.state.tempFilters);  
    }

    static refreshDashboardGrid() {
        self.refreshStatusGrid();
    }

    //RenderContextMenuPopUp(popUpName: string) {
    //    switch (popUpName) {
    //        case 'SendEmail':
    //            return <EmailControl reeferStatusResult={self.state.selectedItems} columnDefinition={self.state.columnDefs} parentchild={"P"} formname={"DryStatusGrid"} />;

    //    }
    //}

    static refreshToggleFilters() {
        if (self != undefined) {
            if (self.state.ToggleSearchParams != undefined && self.state.ToggleSearchParams != null)
                self.setState({ ToggleSearchParams: null });
            self.setState({ rowData: [] });
        }
    }
    closeToolBarGridPreferenceModel() {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }
    ComponentRenderingForCommands(popUpName: string, userData: any) {
        switch (popUpName) {
            //case 'SendEmail':
            //return <EmailControlExcel reeferStatusResult={self.state.selectedItems} columnDefinition={self.state.columnDefs} parentchild={"C"}
            //    formname={"DryGrid"} />;
            case 'SendEmail':
                return <EmailControlExcelPreference reeferStatusResult={self.state.selectedItems} columnDefinition={self.state.columnDefs}
                    colDefs2={columnDefs2} parentchild={"C"} formName={"DryGrid"} FunctionID={functionId}
                    gridApiParams={self.state.gridApiParams} onlyselected={true} sensorData={dryAssetSensors}
                    widgetId={16} dashboardPreferenceId={this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    isIncludeRowGroup={self.state.gridApiParams.gridOptionsWrapper == undefined
                        && self.state.gridApiParams.gridOptionsWrapper == null ? false :
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false} />
            case 'Export':
                return <ExportToExcelConfirmationWindow formName={"DryGrid"} functionId={functionId} gridApiParams={self.state.gridApiParams}
                    gridData={self.state.selectedItems} colDefs={this.state.columnDefs} colDefs2={columnDefs2} IsServerSideEnabled={true}
                    widgetId={16} dashboardPreferenceId={this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    parentchild={"C"} formname={"DryGrid"} onlyselected={true} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} sensorData={dryAssetSensors} />;

            case 'Ping':
                return <DryPingControl dryData={self.state.selectedItems} refreshGrid={"home"}></DryPingControl>;
            case 'MRRI':
                return <MRelatedReportingInterval dryData={self.state.selectedItems} refreshGrid={"status"}></MRelatedReportingInterval>;
            case 'AssignCustomer':
                return <AssignToCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} assetData={self.state.selectedItems} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'UnAssignCustomer':
                return <UnassignReefersFromCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} SelectedReefersData={self.state.selectedItems} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
        }
    }

    RenderContextMenuPopUp(popUpName: string, isCommands: boolean) {
        var dryData = self.state.selectedItems;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var filterSet: server.DryStatusData[];
        filterSet = dryData;
        var filterParams = JSON.stringify(filterSet);
        if (!isCommands) {
            self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) }, () => { self.props.getCommandPopupTitle(this.state.modelTitle); self.props.getCommandPopupContent(this.state.popUpHtml); });
            $('#btnTriggerPopupDry').click();
        }
    }

    popUpPing() {
        self.setState({ modelTitle: 'Ping' });
        self.RenderContextMenuPopUp('Ping', false);
    }

    popUpRelatedReportingInterval() {
        self.setState({ modelTitle: 'Motion-Related Reporting Intervals' });
        self.RenderContextMenuPopUp('MRRI', false);
    }

    popUpAssignToCustomer() {
        $('#globalLoader').show();
        customerAccessData = [];
        self.setState({ modelTitle: 'Assign Asset(s) to Customer' });
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.AssetMasterID : selectedUnits + "," + value.AssetMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].AssetMasterID.toString();
        }
        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.AssetMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetAssetCustomerGroups';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('AssignCustomer', false);
            });
    }

    popUpUnAssignFromCustomer() {
        $('#globalLoader').show();
        self.setState({ modelTitle: 'Unassign Asset(s) From Customer' });
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.AssetMasterID : selectedUnits + "," + value.AssetMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].AssetMasterID.toString();
        }
        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.AssetMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetAssetCustomerGroups';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('UnAssignCustomer', false);
            });
    }

    popUpSendEmail() {
        self.setState({ modelTitle: 'Send Email' });
        self.RenderContextMenuPopUp('SendEmail', false);
    }
    popUpExport() {
        self.setState({ modelTitle: 'Export' });
        self.RenderContextMenuPopUp('Export', false);
    }
    exportToExcel() {
        var arrData;
        if (self.state.selectedItems != null) {
            arrData = typeof self.state.selectedItems != 'object' ? JSON.parse(self.state.selectedItems) : self.state.selectedItems;
        }
        else {
            arrData = typeof this.state.rowData != 'object' ? JSON.parse(this.state.rowData) : this.state.rowData;
        }

        var r = this.state.columnDefs;

        try {
            var formName = 'DryGrid';
            var uri = Excel.InitializeChildGridExportToExcel(arrData, r, formName);
            this.state.exportFields.ExportData = JSON.stringify(uri);
            var sheetData = { HeaderData: [], ColumnData: [] };
            sheetData = Excel.ConvertCSVToJSon(uri);
            GridDryStatusToolBar.applySheetData(sheetData, formName);
        }
        catch (ex) {
            PopupWindow.showErrorMessage("Alert", "Error in data export.");
        }

    }

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }

    onFirstDataRendered(params) {
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = preferenceData.SelectedRowGroups
                    if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0) {
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
                    }
                    if (preferenceData.colState != null && preferenceData.colState != undefined && preferenceData.colState.length > 0) {
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnState(preferenceData.colState);
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState({ state: preferenceData.colState, applyOrder: false, });
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState(preferenceData.colState);
                    }
                }
            });

    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    renderEmailDialog(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, widgetId: any, gridApiParams: any, isIncludeRowGroup: boolean, sensorData: any) {
        this.props.renderDataToEmailControl(gridData, colDefs, colDefs2, formName, parentChild, functionId, widgetId, gridApiParams, isIncludeRowGroup, dryAssetSensors);
    }

    renderGridPreferenceDialog(functionId: any, gridApiParams: any, formName: string) {
        this.props.renderDataGridPreferenceControl(functionId, gridApiParams, formName);
    }

    renderExportToExcelDialog(functionId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData: any) {
        this.props.renderDataGridExportToExcelControl(functionId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild, dryAssetSensors);
    }

    validateRevisionNum(dashboardPreferenceId: any) {
        this.props.validateRevisionNum(dashboardPreferenceId);
    }
    
    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function (item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function () {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "DryStatusGrid");
            },
        });
        return finalMenuItem;
    }

    onColumnResized = (params: any) => {
        console.log("column resized..");
        self.onSaveGridRowGroupState(params);
    }

    public render() {
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];
        return <div>
            <div className='dashboard-GridToolbar'>
                <GridDryStatusToolBar
                    refreshGrid={this.refreshStatusGrid.bind(this)}
                    gridData={this.state.rowData}
                    colDefs={this.state.columnDefs}
                    colDefs2={columnDefs2}
                    gridApiParams={this.state.gridApiParams}
                    parentchild={"C"}
                    formName={"DryStatusGrid"}
                    sourceFrom='Dashboard'
                    sensorData={dryAssetSensors}
                    dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    isReadOnly={this.props.isReadOnly}
                    revisionNum={this.props.revisionNum}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    validateRevisionNum={this.validateRevisionNum.bind(this)}
                    IsServerSideEnabled={ true}                    
                    renderGridPreferenceDialog={this.renderGridPreferenceDialog.bind(this)}
                    renderEmailDialog={this.renderEmailDialog.bind(this)}
                    renderExportToExcelDialog={this.renderExportToExcelDialog.bind(this)} />
            </div>
            <div className='aggrid-icons'>
                <button type="button" className="btn btn-outline-secondary clearselectionBtn"
                    //onClick={this.ClearSelection.bind(this)}
                    onClick={this.props.renderClearSelection.bind(this)}
                    title='Clear Selection'><span className='fa-regular fa-eraser'></span> </button>
            </div>
           
            <div className="ag-theme-fresh Dashboard-Grid-height" id='DRY-grid'>
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    //rowData={this.state.rowData}
                    rowModelType={this.state.rowModelname}
                    serverSideStoreType={this.state.serverSideStoreType}
                    onGridReady={this.onGridReadyServer}
                    animateRows={true}
                    cacheBlockSize={1000}
                    //rowGroupPanelShow={this.state.rowGroupPanelShow}
                    //autoGroupColumnDef={this.state.autoGroupColumnDef}
                    //suppressDragLeaveHidesColumns={true}
                    //suppressMakeColumnVisibleAfterUnGroup={true}
                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                    processCellForClipboard={this.ProcessCellForClipboard}
                    //onColumnRowGroupChanged={this.onSaveGridRowGroupState.bind(this)}
                    onDragStopped={this.onSavecolumnorder.bind(this)}
                    //onSortChanged={this.onSort.bind(this)}
                    //onColumnPinned={this.onSaveGridRowGroupState.bind(this)}
                    //onColumnResized={Formatters.debounce(this.onColumnResized, 1000)}
                    //groupRowRendererParams={groupRowRendererParams}
                    //getMainMenuItems={this.getMainMenuItems.bind(this)}
                    //groupRowInnerRenderer={this.groupRowInnerRenderer}  
                    enableRangeSelection={true}
                    pagination={true}
                    rowSelection={'multiple'}
                    //accentedSort={true}
                    rowDeselection={true}
                    onRowDataChanged={this.onRowDataChanged}
                    excelStyles={excelStyles}
                    onSelectionChanged={this.onGridSelectionChanged}
                    onPaginationChanged={this.onGridPaginationChanged}
                    paginationPageSize={this.state.pageSize}
                    //allowContextMenuWithControlKey={true}
                    getContextMenuItems={this.getDryContextMenuItems}
                    frameworkComponents={this.state.frameworkComponents}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                    tooltipShowDelay={0}
                    tooltipHideDelay={8000}
                    onBodyScroll={this.onGridScroll}>
                </AgGridReact>
            </div>
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="1000">1000</option>
                </select>
            </div>
            <div className='row' id="drycontextmenu">
                <button id="btnTriggerDry" className='btnContext' onClick={this.props.onOpenCommandWindow} />
                <button id="btnTriggerPopupDry" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModel" />
            </div>
        </div>;
    }
}

interface DryMasterStatus {
    DryCurrentConditionId: number;
    EventDTTM?: Date;
    StrEventDTTM: string;
    CreatedDTTM?: Date;
    EventDescription: string;
    AssetNumber: string;
    FenceName: string;
    BackendGeofenceName: string;
    RegionGeofence: string;
    RegionGeofenceName: string;
    GeofenceDefinitionRevision: string;
    City: string;
    State: string;
    Country: string;
    ZipCode: string;
    BattVoltage: number;
    GPSCoords: string;
    StrGPSDTTM: string;
    GPSHDOP: string;
    GPSSatelliteCount: string;
    CountryName: string;
    MNC: string;
    TowerLocalizationAreaCode: string;
    TowerBaseStationID: string;
    RCDID: string;
    FirmwareVersion: string;
    DeviceBattery: string;
    MSISDN: string;
    SIM_IMSI: string;
    ICCID: string;
    EUI: string;
    RSSI: string;
    Speed: number;
    DeviceConfig: string;
    DeviceType: string;
    RCDReportingInterval: string;
    CustomerName: string;
    ErrorMessage: string;
    Sensor1Value: number;
    Sensor2Value: number;
    Sensor3Value: number;
    Sensor4Value: number;
    Sensor5Value: number;
    Sensor6Value: number;
    Sensor7Value: number;
    Sensor8Value: number;
}

//WI-23853
enum ReeferAndGensetAndChassisStatusEnum {
    AllReefer = 0,
    Running = 1,
    Stopped = 2,
    MissedRunning = 3,
    MissedStopped = 4,
    AllMicroAlaram = 5,
    MASevere = 6,
    MAMinor = 7,
    AllCargoCare = 8,
    CCSevere = 9,
    CCMinor = 10,
    CCInformational = 11,

    PowerOnReporting = 12,
    PowerOnNotReporting = 13,
    PowerOffReporting = 14,
    PowerOffNotReporting = 15,

    ChassisPwrInGeofence = 18,
    ChassisPwrOutGeofence = 19,
    ChassisNotPwrInGeofence = 20,
    ChassisNotPwrOutGeofence = 21
}